// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MediaTypeInput } from './mediaTypeInput';
import type { ExportedResourceUrl } from './exportedResourceUrl';
import type { ExportedResourceResourceId } from './exportedResourceResourceId';

/**
 * Resource in export format
 */
export interface ExportedResource {
  title: string;
  description?: string;
  citation?: string;
  media_type: MediaTypeInput;
  url?: ExportedResourceUrl;
  resource_id?: ExportedResourceResourceId;
}
